import { render, staticRenderFns } from "./TncContent.vue?vue&type=template&id=1e199d18&"
import script from "./TncContent.vue?vue&type=script&lang=js&"
export * from "./TncContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports